import React from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import Image from 'next/legacy/image';

import { getStaticCDN } from '@design-system/utils/utils';
import useWindowResize from '@source/hooks/useWindowResize';

const StyledHeader = styled.section`
  position: relative;
  background-color: black;
  height: 250px;
  ${(props) => props.theme.typo.familyGoogle.regular}

  .background-header {
    opacity: 0.5;
  }

  .title {
    font-size: 1.5rem;
    color: ${(props) => props.theme.color.onPrimary};
    text-align: center;
    line-height: 27px;
    margin-bottom: 24px;
  }

  .subtitle {
    margin-bottom: 0;
    font-size: 1.25rem;
    line-height: 25px;
    color: ${(props) => props.theme.color.onPrimary};
  }

  .hero-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    position: relative;
    z-index: 10;
  }
`;

const AboutBanner = () => {
  const [width] = useWindowResize();
  const { t } = useTranslation('aboutUs');

  return (
    <StyledHeader className="hero">
      <Image
        src={getStaticCDN('/static/img/pageHeaders/about/about-carro-singapore-car-marketplace.webp')}
        layout="fill"
        objectFit="cover"
        className="background-header"
        priority
        loading="eager"
      />
      <div className="hero-body">
        <h1 className="title">{t('aboutUs.title')}</h1>
        {width > 768 && <p className="subtitle">{t('aboutUs.subtitle')}</p>}
      </div>
    </StyledHeader>
  );
};

export default AboutBanner;
